import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { RESYNC_PLC_SECURITIES } from './actionTypes';
import { resyncPlcSecuritiesSuccessful, resyncPlcSecuritiesFailed } from './actions';

import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

function* resyncPlcSecurities({ payload: { request } }) {
  try {
    const response = yield call(tasksAPI.resyncSecurities, request.token);
    yield put(resyncPlcSecuritiesSuccessful(response));
  } catch (error) {
    yield put(resyncPlcSecuritiesFailed(error));
  }
}

export function* watchResyncPlcSecurities() {
  yield takeEvery(RESYNC_PLC_SECURITIES, resyncPlcSecurities);
}

function* resyncPlcSecuritiesSaga() {
  yield all([fork(watchResyncPlcSecurities)]);
}

export default resyncPlcSecuritiesSaga;
